import React from 'react';
import {
  Type, ImageIcon, MousePointerClick, Minus, Columns2, Space, Share2,
  PanelTop, PanelBottom, FileSignature, GripVertical
} from 'lucide-react';
import { EMAIL_BLOCK_CATEGORIES, EMAIL_BLOCK_REGISTRY } from './emailBlockRegistry';

const ICONS = { Type, ImageIcon, MousePointerClick, Minus, Columns2, Space, Share2, PanelTop, PanelBottom, FileSignature };

/**
 * Left sidebar — draggable block type palette.
 */
export default function EmailBlockPalette({ onAddBlock }) {
  return (
    <div className="w-[180px] flex-shrink-0 border-r border-stone-200 bg-stone-50/50 overflow-y-auto">
      <div className="p-3">
        <p className="text-[10px] font-semibold text-stone-400 uppercase tracking-wider mb-3">Blocks</p>
        {EMAIL_BLOCK_CATEGORIES.map(cat => {
          const blocks = Object.entries(EMAIL_BLOCK_REGISTRY).filter(([, def]) => def.category === cat.id);
          if (!blocks.length) return null;
          return (
            <div key={cat.id} className="mb-4">
              <p className="text-[9px] font-semibold text-stone-400 uppercase tracking-wider mb-1.5">{cat.label}</p>
              <div className="space-y-1">
                {blocks.map(([type, def]) => {
                  const Icon = ICONS[def.icon] || Type;
                  return (
                    <button key={type} onClick={() => onAddBlock(type)}
                      className="w-full flex items-center gap-2 px-2.5 py-2 text-xs text-stone-600 hover:bg-white hover:text-stone-900 rounded-lg border border-transparent hover:border-stone-200 hover:shadow-sm transition-all group text-left"
                      title={def.description}>
                      <GripVertical className="w-3 h-3 text-stone-300 group-hover:text-stone-400 flex-shrink-0" />
                      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
                      <span className="truncate">{def.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
